import { render, staticRenderFns } from "./wtr-btn.vue?vue&type=template&id=a0077b84&"
import script from "./wtr-btn.vue?vue&type=script&lang=js&"
export * from "./wtr-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports